import { RadioSelectOption } from '../../../shared/interfaces/project-interfaces';

export interface VerifyIdSelectOptions extends RadioSelectOption {
  id: string;
  infoText: string;
  fileUploadTitle: string;
  sideGraphic?: string;
  imageWidth: number;
  imageHeight: number;
  placeholder: string;
}

export const verifyIdSelectOptions: VerifyIdSelectOptions[] = [
  {
    label: 'South African Smart ID',
    checked: false,
    id: 'smartId',
    name: 'smartIdField',
    icon: 'iconoir-user-circle',
    infoText: `Please ensure the text is clear and your entire card is visible. <br>
      Please ensure that the image is landscape-orientated.`,
    fileUploadTitle: 'Upload Front',
    imageWidth: 900,
    imageHeight: 600,
    placeholder: 'Enter your identity number',
  },
  {
    label: 'South African Green ID Booklet',
    checked: false,
    id: 'greenId',
    name: 'greenIdField',
    icon: 'iconoir-user-square',
    infoText: `Only the right-hand page of the ID Book is required. <br>
      Please ensure that the image is portrait-orientated.`,
    fileUploadTitle: 'Upload Green ID Booklet',
    imageWidth: 500,
    imageHeight: 750,
    placeholder: 'Enter your identity number',
  },
  {
    label: 'International Passport',
    checked: false,
    id: 'passport',
    name: 'passportField',
    icon: 'pays-icon ic-globe',
    infoText: `Please ensure the text is clear and visible. <br>
      Please ensure that the image is portrait-orientated.`,
    fileUploadTitle: 'Upload International Passport',
    imageWidth: 900,
    imageHeight: 600,
    placeholder: 'Enter your passport number',
  },
];
